import { notification } from "antd";
import { actionTypes } from "./base/action/action";
import { sharingState } from "./base/models/meetModal";
import { videoCallService } from "./base/service/videoCallService";
import store from "./store/redux-store/root_store";

let isDrawing:any=false;
let canvasAgent:any=null;
let rectAgent:any=null;
let contextAgent:any=null;
let options:any="";
let guid:any="0000"
let startPoint:any = {};
let isClear:any=false;
let endPoint:any = {};
let localVideoHeight:any=0;
let localVideoWidth:any=0;
export const startCanvascanvasAgent=()=>{
    canvasAgent= document.getElementById("canvaagent");
    if(canvasAgent){let mainBoard:any=document.getElementById('screenShareVideo');
    canvasAgent.height=mainBoard?.offsetHeight;
    canvasAgent.width=mainBoard?.offsetWidth;
    rectAgent=canvasAgent.getBoundingClientRect();
    contextAgent = canvasAgent.getContext("2d");}
}

export const toast=(msg:any)=>{
  notification.info({
    message: msg,
    placement: "top",
    className: "toastNotification success",
    icon: <span className="icon__Success24" />,
    closeIcon: <span className="icon__IconCloseNew16" />,
    duration: 3,
    top: 70,
  });
}

export const toastMsg=(msg:string,variant:string)=>{
  notification.info({
    message: msg,
    placement: "top",
    className: `toastNotification ${variant==='success'?'success':'error'}`,
    icon: <span className={variant==='success'?`icon__Success24`:'icon__Error24'} />,
    closeIcon: <span className="icon__IconCloseNew16" />,
    duration: 3,
    top: 70,
  });
}

export const moveClick=(e:any)=>{
    if(!contextAgent || !rectAgent){
        startCanvascanvasAgent();
    }
    if(!canvasAgent){canvasAgent= document.getElementById("canvaagent");
    let mainBoard:any=document.getElementById('screenShareVideo');
    canvasAgent.height=mainBoard?.offsetHeight;
    canvasAgent.width=mainBoard?.offsetWidth;}
    isDrawing = true;
    guid = uuidv4();
    startPoint = getCanvasCoordinates(e);
    sendPoints();
}

export const getCanvasCoordinates = (event:any) =>{
    return {
    x: event.clientX - rectAgent.left,
    y: event.clientY - rectAgent.top
    };
    }
export const mouseMove=(e:any)=>{
    if(!contextAgent|| !rectAgent){
        startCanvascanvasAgent();
    }
    if(!canvasAgent){    canvasAgent= document.getElementById("canvaagent");}

        if (!isDrawing) return;
        endPoint = getCanvasCoordinates(e);
        sendPoints();
        startPoint = endPoint;


    }
        


export const setRemoteVideo=(width:any,height:any)=>{
    localVideoWidth=width;
    localVideoHeight=height;
}


export const moveRelease=(e:any)=>{
    const{currdeviceinfo}=store.getState().meetingReducer;
    const {annotation}=store.getState().sharingReducerState;
    if(!contextAgent || !rectAgent){
        startCanvascanvasAgent();
    }
    if(!canvasAgent){    canvasAgent= document.getElementById("canvaagent");}
    isDrawing = false;
    sendPoints();
    startPoint={};endPoint={};

}

export const sendPoints=()=>{
    const{currdeviceinfo}=store.getState().meetingReducer;
    const {annotation}=store.getState().sharingReducerState;
    let annotationdetails:any=annotation || [];
    let jsonData: any = {};
    jsonData.id = guid;
    jsonData.shape = options ;
    jsonData.x1 = startPoint.x;
    jsonData.y1 = startPoint.y;
    jsonData.x2 = endPoint.x;
    jsonData.y2 = endPoint.y;
    jsonData.userId = currdeviceinfo?.conId || '';
    jsonData.movePoints = [];
    jsonData.isVisible = false;
    jsonData.deviceId = currdeviceinfo.deviceid;
    let index = annotationdetails.findIndex((elem: any) => (elem.id.toString() === jsonData.id.toString()));
    if (index !== -1) {
        let moves: any = { x1: startPoint.x, y1: startPoint.y ,x2:endPoint.x,y2:endPoint.y};
        annotationdetails[index].movePoints.push(moves);

    }
    else {
      if(annotationdetails.length > 0 && annotationdetails[annotationdetails.length-1].movePoints && annotationdetails[annotationdetails.length-1].movePoints.length ===1){
        annotationdetails.pop();
      }
      annotationdetails.push(jsonData); }
    drawLineAgent(annotationdetails);
    store.dispatch({
        type: actionTypes.ANNOTATE,
        payloads: {annotation:annotationdetails,annotationCopy:annotationdetails}
      });
    let input = {
        conId: currdeviceinfo?.conId,
        message: JSON.stringify(jsonData),
        username: currdeviceinfo?.name
      };
      videoCallService.sendWhiteboardData(input);
}

export const clearall = () => {

  const { annotation } = store.getState().sharingReducerState || [];
    const {currdeviceinfo}=store.getState().meetingReducer;
  let jsonData: any = {};
  jsonData.shape = 'clear';
  jsonData.userId = currdeviceinfo?.conId;
  jsonData.deviceId = store.getState().meetingReducer.currdeviceinfo.deviceid;
  let input = {
    sipId: currdeviceinfo?.conId,
    message: JSON.stringify(jsonData),
    username: currdeviceinfo?.name
  };
  isClear=true;
  videoCallService.sendWhiteboardData(input);
  store.dispatch({
    type: actionTypes.ANNOTATE,
    payloads: {annotation:[],annotationCopy:annotation}
  });
  contextAgent.fillStyle='rgba(0,0,0,0)'
  contextAgent.clearRect(0,0,canvasAgent.width,canvasAgent.height);
}

export const setAnnotateOpt=(opt:any)=>{
  options=opt;
  if(opt!=="redo" && opt !=="clear"){isClear = false;}
  if(opt ==="undo"){undo()}
  else if(opt ==="redo"){redo()}
  else if(opt ==="clear"){clearall()}
}

export const reset=()=>{
  options="";
  startPoint={};endPoint={};
  isClear=false;
}

export const  drawLineAgent=(annotationdata:any)=> {
    const{remoteVideoSize}:any=store.getState().sharingReducerState;
    if(contextAgent !==null || rectAgent!==null ){
        startCanvascanvasAgent();
    }
    if (contextAgent === null) { return; }
    clearCanvas();

    annotationdata.forEach((element: any, index: number) => {
    let {lineWidth,isVisible,movePoints}:any=element;
    if (isVisible) {
    return true
    };
    contextAgent.beginPath();
    
   if(element.shape === 'pencil'){ contextAgent.strokeStyle = "#EB3F67";
    contextAgent.lineWidth = lineWidth;
    contextAgent.shadowBlur = 0;
    let point = movePoints;

    point.forEach(function (axis: any) {
    contextAgent.globalCompositeOperation = 'source-over'
    contextAgent.moveTo(axis.x1,axis.y1)
    contextAgent.lineTo(axis.x2,axis.y2)

 
    contextAgent.stroke();
    });}
    if(element.shape ==="eraser"){
    contextAgent.globalCompositeOperation = 'destination-out';
    contextAgent.strokeStyle = "#fff";
    contextAgent.lineWidth = lineWidth;
    contextAgent.shadowBlur = 0;
    let point = movePoints;

    point.forEach(function (axis: any) {

    contextAgent.moveTo(axis.x1,axis.y1)
    contextAgent.lineTo(axis.x2,axis.y2)

 
    contextAgent.stroke();
    });
    }
    
    contextAgent.imageSmoothingEnabled = true;
    contextAgent.closePath();
    
    })
}

export const undo = () => {
    const { annotation } = store.getState().sharingReducerState || [];
    const {currdeviceinfo}=store.getState().meetingReducer;
    let annotationDet:any = annotation;
    for (let i = annotationDet?.length - 1; i >= 0; i--) {
      if (!annotationDet[i].isVisible && annotationDet[i].deviceId === currdeviceinfo.deviceid) {
        annotationDet[i].isVisible = true;
        drawLineAgent(annotationDet);
        store.dispatch({
          type: actionTypes.ANNOTATE,
          payloads: {annotation:annotationDet,annotationCopy:annotationDet}
        });
  
        let jsonData: any = {};
        jsonData.shape = 'undo';
        jsonData.id = annotationDet[i].id;
        jsonData.confId = currdeviceinfo?.conId;
        jsonData.deviceId =currdeviceinfo.deviceid;
        let input = {
          conId: currdeviceinfo.conId,
          message: JSON.stringify(jsonData),
          username: currdeviceinfo?.name
        };
        videoCallService.sendWhiteboardData(input);
        return;
      }
    }
  };

  export const redo = () => {
    console.log("clearrr & redo",isClear);
    const { annotation ,annotationCopy}:any = store.getState().sharingReducerState || [];
    let meetingdetails = annotation;
    const {currdeviceinfo}=store.getState().meetingReducer;
    //let conid:string = devicesInfo[deviceid]?.conId;
    let currentDeviceId: string = currdeviceinfo?.deviceid;
    if(!isClear){for (let i = meetingdetails.length-1;i>=0; i--) {
 
     if (meetingdetails && meetingdetails[i].isVisible && meetingdetails[i].deviceId === currentDeviceId) {
        meetingdetails[i].isVisible = false;
        drawLineAgent(meetingdetails);
        store.dispatch({
            type: actionTypes.ANNOTATE,
            payloads: {annotation:meetingdetails,annotationCopy:meetingdetails}
          });
  
        let jsonData: any = {};
        jsonData.shape = 'redo';
        jsonData.id = meetingdetails[i].id;
        jsonData.userId = currdeviceinfo?.conId;
        jsonData.deviceId = store.getState().meetingReducer.currdeviceinfo.deviceid;
        let input = {
          conId: currdeviceinfo?.conId,
          message: JSON.stringify(jsonData),
          username: currdeviceinfo?.name
        };
        videoCallService.sendWhiteboardData(input);
        return;
      }
    }}
    else{
      let jsonData: any = {};
      jsonData.shape = 'redo';
      jsonData.id = "";
      jsonData.userId = "";
      jsonData.deviceId = store.getState().meetingReducer.currdeviceinfo.deviceid;
      jsonData.isClear=isClear;
      
      let input = {
        conId: currdeviceinfo?.conId,
        message: JSON.stringify(jsonData),
        username: currdeviceinfo?.name
      };
      drawLineAgent(annotationCopy);
      store.dispatch({
        type: actionTypes.ANNOTATE,
        payloads: {annotation:annotationCopy,annotationCopy:annotationCopy}
      });
      videoCallService.sendWhiteboardData(input);
      return;
    }
  };

export const  drawLineCustomer=(annotationdata:any)=> {
    const{remoteVideoSize}:any=store.getState().sharingReducerState;
    console.log("remoteVideoSizeremoteVideoSize>>",remoteVideoSize);
    if(contextAgent !==null || rectAgent!==null ){
        startCanvascanvasAgent();
    }
    if (contextAgent === null) { return; }
    clearCanvas();
    annotationdata.forEach((element: any, index: number) => {
    let {lineWidth,isVisible,movePoints}:any=element;
    if (isVisible) {
    return true
    };
    contextAgent.beginPath();
    
    if(element.shape==="pencil"){    contextAgent.strokeStyle = "#EB3F67";
    contextAgent.lineWidth = lineWidth;
    contextAgent.shadowBlur = 0;
    let point = movePoints;

    point.forEach(function (axis: any) {

    
    const widthScale = canvasAgent.width / parseInt(remoteVideoSize?.width);
    const heightScale = canvasAgent.height / parseInt(remoteVideoSize?.height);

    let scaledX1 = axis.x1 * widthScale;
    let scaledY1 = axis.y1 * heightScale;
    let scaledX2 = axis.x2 * widthScale;
    let scaledY2 = axis.y2 * heightScale;
    contextAgent.globalCompositeOperation="source-over"
    contextAgent.moveTo(scaledX1, scaledY1);
    contextAgent.lineTo(scaledX2, scaledY2);
    contextAgent.stroke();
    });}

    if(element.shape==="eraser"){    
    contextAgent.strokeStyle = "#fff";
    contextAgent.lineWidth = lineWidth;
    contextAgent.shadowBlur = 0;
    let point = movePoints;

    point.forEach(function (axis: any) {

    
    const widthScale = canvasAgent.width / parseInt(remoteVideoSize?.width);
    const heightScale = canvasAgent.height / parseInt(remoteVideoSize?.height);

    let scaledX1 = axis.x1 * widthScale;
    let scaledY1 = axis.y1 * heightScale;
    let scaledX2 = axis.x2 * widthScale;
    let scaledY2 = axis.y2 * heightScale;
    contextAgent.globalCompositeOperation="destination-out"
    contextAgent.moveTo(scaledX1, scaledY1);
    contextAgent.lineTo(scaledX2, scaledY2);
    contextAgent.stroke();
    });}
    
    contextAgent.imageSmoothingEnabled = true;
    contextAgent.closePath();
    
    })
}

export const clearCanvas=()=>{
  contextAgent.clearRect(0, 0, canvasAgent.width, canvasAgent.height);
  contextAgent.fillStyle='rgba(0,0,0,0)'
}

export const resizeCanvas=(msg:any)=>{

        
}

export const checkShareStatus = () => {
  try {
    const isScreenShare: sharingState = store.getState().sharingReducerState || [];
    const {annotationEnable}:any=store.getState().sharingReducerState;
      const { sockmeetDetails } = store.getState().meetingReducer;
    let { currdeviceinfo } = store.getState().meetingReducer || [];
    let shareStatus: any = { "status": true, "error": "" };
    if (isScreenShare.sharingStatus) {
      if (isScreenShare.conId === currdeviceinfo.conId+"_screenshare" && !annotationEnable) {
        shareStatus.status = false;
        shareStatus.error = "Already you are sharing the screen";
      }
      else{
        shareStatus.status = false;
        shareStatus.error = "Already customer is sharing the screen";
      }
    }
    return shareStatus;
  }
  catch (e: any) { console.log("error is", e); }
};

export const remoteredo = (data: any) => {
  const {currdeviceinfo}:any=store.getState().meetingReducer;
  const {annotationCopy}:any=store.getState().sharingReducerState;
  if (data.confId !== currdeviceinfo?.conId) {
    let { annotation } = store.getState().sharingReducerState || [];
    let meetingdetails = annotation;
    let index: number = meetingdetails.findIndex((elem: any) => (elem.id === data.id));
    if (index !== -1) {
      meetingdetails[index].isVisible = false;
      
      drawLineCustomer(meetingdetails);
      store.dispatch({
        type: actionTypes.ANNOTATE,
        payloads: {annotation:meetingdetails,annotationCopy:meetingdetails}
      });
    }
    console.log(annotation,"annotationannotation===");
    if(data.isClear){
      drawLineCustomer(annotationCopy);
      store.dispatch({
        type: actionTypes.ANNOTATE,
        payloads: {annotation:annotationCopy,annotationCopy:annotationCopy}
      });
    }
  }
};

export const remoteclearall = () => {
  let { annotation } = store.getState().sharingReducerState || [];
  
  store.dispatch({
    type: actionTypes.ANNOTATE,
    payloads: {annotation:[],annotationCopy:annotation}
  });
  contextAgent.fillStyle='rgba(0,0,0,0)'
  contextAgent.clearRect(0,0,canvasAgent.width,canvasAgent.height);


}

export const receivingPoint=(points:any)=>{
    const {currdeviceinfo}=store.getState().meetingReducer;
    const {annotation}=store.getState().sharingReducerState;
    let annotatedet:any=annotation || []
    if(currdeviceinfo.conId !== points.userId){
    if(points.shape ==="undo"){
        remoteUndo(points);
    }
    else  if(points.shape ==="redo"){
      remoteredo(points);
  }
  else if(points.shape === "clear"){
    remoteclearall();
}
    else if((points.shape ==="pencil" || points.shape ==="eraser" ) && currdeviceinfo && currdeviceinfo.conId !== points.userId) {
      let storePoints: any = {};
      storePoints.id = points.id;
      storePoints.movePoints = [];
      storePoints.shape = points.shape;
      storePoints.x1 = points.x1;
      storePoints.y1 = points.y1;
      storePoints.x2 = points.x2;
      storePoints.y2 = points.y2;
      storePoints.isVisible = false;
      storePoints.userId = points.userId;
      storePoints.deviceId = points.deviceId;
      let index = annotatedet.findIndex((elem: any) => (elem.id.toString() === points.id.toString()));
      if (index !== -1) {
          let moves: any = { x1: points.x1, y1: points.y1,x2:points.x2,y2:points.y2 };
          annotatedet[index].movePoints.push(moves);

      }
          else {
        if(annotatedet?.length > 0 && annotatedet[annotatedet.length-1]?.movePoints?.length ===1){
          annotatedet.pop();
        }
        annotatedet.push(storePoints); }
      drawLineCustomer(annotatedet);
      store.dispatch({
          type:actionTypes.ANNOTATE,
          payloads:{
              annotation:annotatedet,annotationCopy:annotatedet
          }
      })
    }
  }
    }

    export const remoteUndo = (data: any) => {
        const {currdeviceinfo}:any=store.getState().meetingReducer;
        if (data.confId !== currdeviceinfo?.conId) {
          let { annotation } = store.getState().sharingReducerState || [];
          let annotatedet:any = annotation;
          let index: number = annotatedet.findIndex((elem: any) => (elem.id === data.id));
          if (index !== -1) {
            annotatedet[index].isVisible = true;
            drawLineCustomer(annotatedet);
            store.dispatch({
              type: actionTypes.ANNOTATE,
              payloads: {annotation:annotatedet,annotationCopy:annotatedet}
            });
          }
        }
      };

      export const getIcon=()=>{
        return options;
      }

    
export const uuidv4 = () => {
    return "xxx-xxx-xxxx".replace(/[xy]/g, function (c) {
      let r = (Math.random() * 8) | 0,
        v = c === "x" ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  };


    
    